import { EditorState, Entity, Modifier } from "draft-js";
import { insertAtomicBlock } from "../../utils/draftjs.internal.utils";
import { getSelectionAsCursorAtEnd, getSelectionAsCursorAtStart, performActions, } from "../../utils/draftjs.utils";
import { CONDITION_RENDERER_TYPE, } from "../Editor/decorators/ConditionRenderer";
var insertConditionPart = function (params) {
    var editorState = params.editorState, condition = params.condition, originalEditorState = params.originalEditorState, instancePosition = params.instancePosition;
    var isStart = instancePosition === "LEADING";
    var contentState = editorState.getCurrentContent();
    var originalSelection = originalEditorState.getSelection();
    var selection = isStart
        ? getSelectionAsCursorAtStart(originalEditorState)
        : getSelectionAsCursorAtEnd(originalEditorState);
    var selectionRemainsWithinSingleBlock = originalSelection.getAnchorKey() === originalSelection.getFocusKey();
    var data = {
        id: condition.id,
        instancePosition: instancePosition,
        renderType: selectionRemainsWithinSingleBlock ? "INLINE" : "BLOCK",
    };
    if (selectionRemainsWithinSingleBlock) {
        var entityKey_1 = Entity.create(CONDITION_RENDERER_TYPE, "IMMUTABLE", data);
        var newContentState = performActions(contentState, [
            function (x) { return Modifier.insertText(x, selection, " "); },
            function (x) {
                return Modifier.insertText(x, selection, "_", undefined, entityKey_1);
            },
            function (x) { return Modifier.insertText(x, selection, " "); },
        ]);
        return EditorState.push(editorState, newContentState, "insert-characters");
    }
    var afterSplit = Modifier.splitBlock(contentState, selection);
    var contentStateWithEntity = afterSplit.createEntity(CONDITION_RENDERER_TYPE, "IMMUTABLE", data);
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    var contentStateWithEntityApplied = Modifier.applyEntity(contentStateWithEntity, selection, entityKey);
    var newEditorState = EditorState.set(editorState, {
        currentContent: contentStateWithEntityApplied,
    });
    return insertAtomicBlock({
        editorState: newEditorState,
        entityKey: entityKey,
        character: "_",
        targetSelection: isStart
            ? contentStateWithEntityApplied.getSelectionBefore()
            : contentStateWithEntityApplied.getSelectionAfter(),
        appendUnstyled: !isStart,
    });
};
export var insertCondition = function (editorState, condition) {
    return performActions(editorState, [
        function (x) {
            return insertConditionPart({
                editorState: x,
                originalEditorState: editorState,
                condition: condition,
                instancePosition: "TRAILING",
            });
        },
        function (x) {
            return insertConditionPart({
                editorState: x,
                originalEditorState: editorState,
                condition: condition,
                instancePosition: "LEADING",
            });
        },
    ]);
};
